/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  SchemaValidationErrorResponse,
  SharedFleetchartLayout,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Shared Fleetchart Layout
 */
export const publicFleetchartLayout = (
    token: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      token = toValue(token);

      return axiosClient<SharedFleetchartLayout>(
      {url: `/public/fleetchart-layouts/${token}`, method: 'GET', signal
    },
      );
    }




export const getPublicFleetchartLayoutQueryKey = (token: MaybeRefOrGetter<string>,) => {
    return [
    'public','fleetchart-layouts',token
    ] as const;
    }


export const getPublicFleetchartLayoutQueryOptions = <TData = Awaited<ReturnType<typeof publicFleetchartLayout>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(token: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetchartLayout>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicFleetchartLayoutQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicFleetchartLayout>>> = ({ signal }) => publicFleetchartLayout(token, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(token) !== null && toValue(token) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicFleetchartLayout>>, TError, TData>
}

export type PublicFleetchartLayoutQueryResult = NonNullable<Awaited<ReturnType<typeof publicFleetchartLayout>>>
export type PublicFleetchartLayoutQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Shared Fleetchart Layout
 */

export function usePublicFleetchartLayout<TData = Awaited<ReturnType<typeof publicFleetchartLayout>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 token: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetchartLayout>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicFleetchartLayoutQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






